import { render, staticRenderFns } from "./OrderSubscriptions.vue?vue&type=template&id=4642a537&scoped=true"
import script from "./OrderSubscriptions.vue?vue&type=script&lang=js"
export * from "./OrderSubscriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4642a537",
  null
  
)

export default component.exports